(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const pausePreview = (card) => {
    const video = card.querySelector('.card__hover-preview-video');
    if (!video) return;

    video.pause();
    video.currentTime = 0;
    card.classList.remove('is-hover-preview-playing');
  };

  const playPreview = (card) => {
    const video = card.querySelector('.card__hover-preview-video');
    if (!video) return;

    card.classList.add('is-hover-preview-playing');

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        card.classList.remove('is-hover-preview-playing');
      });
    }
  };

  const bindCard = (card) => {
    if (card.dataset.hoverPreviewBound === 'true') return;
    if (!card.querySelector('.card__hover-preview-video')) return;

    card.dataset.hoverPreviewBound = 'true';

    if (canHover) {
      card.addEventListener('mouseenter', () => playPreview(card));
      card.addEventListener('mouseleave', () => pausePreview(card));
    }

    card.addEventListener('focusin', () => playPreview(card));
    card.addEventListener('focusout', () => pausePreview(card));
  };

  const bindCards = (root = document) => {
    root.querySelectorAll('.product-card-wrapper').forEach(bindCard);
  };

  const watchDynamicCards = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('.product-card-wrapper')) {
            bindCard(node);
            return;
          }

          bindCards(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindCards();
    watchDynamicCards();
  });
  document.addEventListener('shopify:section:load', (event) => bindCards(event.target));
})();
